<div [ngClass]="{'_load-animate _load-active': closing}">
	<div class="_dialog-title" style="height: 70px">
		<div class="flex-grow-1 text-ellipsis me-2">{{ data.benefit.description }}</div>
		<button mat-mini-fab mat-dialog-close color="accent">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<div class="_dialog-content">
		@if ($storage.order) {
			<div class="px-2 text-base">
				<div class="text-center alert alert-secondary text-base text-center ">
					<div [innerHtml]="capOfOffersToSelect"></div>
					<div style="font-size:1.1em"
						 [innerHtml]="(benefitBasket.length == 1 ? '_LOYALTY.benefit_offers_selected_count_one' : '_LOYALTY.benefit_offers_selected_count') | translate: {val:benefitBasket.length}"></div>
				</div>
			</div>

			<div class="offers-menu-cat" style="border-bottom-width: 0;">
				<menu-offers-container>
					@for (offer of offerGroup.offers; track offer) {

						<div class="menu-offer"
						     [id]="'boffer_' + offer._id"
						     [ngClass]="{'_active':offer._selectedCount}"
						     (mousedown)="selectOffer(offer, $event)" >
							<div class="menu-offer-body">
								<div class="_body">
									<div class="menu-offer-title">{{ offer.name }}</div>
									@if (offer.description_display != 'hide') {
										<div class="menu-offer-description">{{ offer.description }}</div>
									}
									<div class="menu-offer-price">
										@if (offer.price > 0) {
											<div class="_price">{{offer.price | lcurrency}}</div>
										} @else {
											<div class="_price"></div>
										}
										<app-offer-attributes [offer]="offer"></app-offer-attributes>
									</div>


									<!--<div class="menu-offer-price">

										@if (!offer._selectedCount) {
											<button type="button" (mousedown)="selectOffer(offer, $event)"
											        class="btn btn-outline-primary btn-block"
											        [disabled]="offer._selectedCount == data.numberOfOffersToSelect">
												{{ '_LOYALTY.select_item' | translate }}
											</button>
										} @else {
											<div class="_actions">
												<button type="button" (mousedown)="removeSelected(offer, $event)"
												        [class._inactive]="offer.quantity == 1">
													<mat-icon
														[svgIcon]="offer._selectedCount == 1 ? 'trash' : 'minus'"></mat-icon>
												</button>
												<div class="_counter text-highlight">
													{{ offer._selectedCount }}
												</div>
												<button type="button" (mousedown)="selectOffer(offer, $event)"
												        [disabled]="offer._selectedCount == data.numberOfOffersToSelect">
													<mat-icon svgIcon="plus"></mat-icon>
												</button>
											</div>
										}

										<app-offer-attributes [offer]="offer"></app-offer-attributes>
									</div>-->
								</div>
								<!--[class.no-image]="offer.iconImage" [appBgImage]="offer.imageURL" [model]="cat"-->
								<div class="_image" [ngStyle]="offer.catStyle || offer.cardStyle"
								     [class.stock-disabled]="offer.stockDisabled">
									<img [appImageSrc]="offer.imageURL" [model]="offer" loading="lazy"/>
									<app-offer-marketing [offer]="offer" [$storage]="$storage"></app-offer-marketing>
								</div>
							</div>
						</div>

					}
				</menu-offers-container>
			</div>
		}
	</div>
</div>
